import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1129.43333,113 L1129.43333,1807.15 L903.546667,1807.15 L451.773333,1355.37667 L451.773333,564.773333 L903.546667,113 L1129.43333,113 Z M338.83,564.773333 L338.83,1355.37667 L169.415,1355.37667 C76.609463,1355.37667 1.51524776,1281.21051 0.0226440087,1188.76848 L-2.02476258e-10,1185.96167 L-2.02476258e-10,734.188333 C-2.02476258e-10,641.382796 74.1661599,566.288581 166.60819,564.795977 L169.415,564.773333 L338.83,564.773333 Z M1789.95097,635 L1920,764.926457 L1724.98774,959.938714 L1920,1154.95097 L1789.95097,1285 L1595.06129,1089.98774 L1400.04903,1285 L1270,1154.95097 L1465.01226,959.938714 L1270,764.926457 L1400.04903,635 L1595.06129,830.012257 L1789.95097,635 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconAudioOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAudioOffSolid, _Component);

  var _super = _createSuper(IconAudioOffSolid);

  function IconAudioOffSolid() {
    _classCallCheck(this, IconAudioOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAudioOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAudioOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAudioOffSolid.displayName = "IconAudioOffSolid";
  return IconAudioOffSolid;
}(Component);

IconAudioOffSolid.glyphName = 'audio-off';
IconAudioOffSolid.variant = 'Solid';
IconAudioOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAudioOffSolid;
export { IconAudioOffSolid };